export default class GalleryThumbnail {
    constructor(url, variantId) {
        this.originalUrl = url;
        this.variantId = variantId;
        this.video = false;

        let youTubeVideoID = this.getYoutubeHash(url);

        if (youTubeVideoID) {
            this.video = true;
            this.src = 'https://img.youtube.com/vi/' + youTubeVideoID + '/0.jpg';
        } else {
            this.src = url.replace(/\/[0-9]{3,4}\/[0-9]{3,4}\/0$/gm, '/150/113/0');
        }
    }

    getYoutubeHash(url) {
        let regExp = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:shorts\/)?(?:[^\/\n\s]+\/)?|watch\/(?:[^\/\n\s]+\/)?|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/|\S*?[?&]video_id=|youtu\.be\/|embed\/|watch\?v(?:i)?=)([^#\&\?\n\s]{11})/;
        let match = url.match(regExp);

        if (match && match[1].length == 11) {
            return match[1];
        }

        let imageCheck = /img.youtube.com\/vi\/(.*?)\//;
        match = url.match(imageCheck);

        if (match && match[1].length == 11) {
            return match[1];
        }

        return false;
    }
}
